export var IngestionSourceType;
(function (IngestionSourceType) {
    IngestionSourceType["INGESTION_SOURCE_TYPE_S3"] = "S3";
    IngestionSourceType["INGESTION_SOURCE_TYPE_GCS"] = "GCS";
    IngestionSourceType["INGESTION_SOURCE_TYPE_KAFKA"] = "KAFKA";
    IngestionSourceType["INGESTION_SOURCE_TYPE_BUCKET_FILES"] = "BUCKET_FILES";
    IngestionSourceType["INGESTION_SOURCE_TYPE_SAP"] = "SAP";
})(IngestionSourceType || (IngestionSourceType = {}));
